// extracted by mini-css-extract-plugin
export default {"container":"XH6bkD","logo":"jpWBUA","nowrap":"QiYWQy","modalTrigger":"tAVnGX","extraSpace":"XHQstY"};